<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SectionLayout from './SectionLayout.vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';

const hiddenItems = defineModel({ type: Array, default: () => [] });

const { t } = useI18n();

const options = computed(() => [
  { key: 'Inbox', label: t('SIDEBAR.INBOX') },
  { key: 'Conversation', label: t('SIDEBAR.CONVERSATIONS') },
  { key: 'Captain', label: t('SIDEBAR.CAPTAIN') },
  { key: 'Contacts', label: t('SIDEBAR.CONTACTS') },
  { key: 'Companies', label: t('SIDEBAR.COMPANIES') },
  { key: 'Operations', label: t('OPERATIONS.SIDEBAR') },
  { key: 'Reports', label: t('SIDEBAR.REPORTS') },
  { key: 'Campaigns', label: t('SIDEBAR.CAMPAIGNS') },
  { key: 'Portals', label: t('SIDEBAR.HELP_CENTER.TITLE') },
]);

const isVisible = key => !hiddenItems.value.includes(key);

const setVisibility = (key, visible) => {
  hiddenItems.value = visible
    ? hiddenItems.value.filter(item => item !== key)
    : [...hiddenItems.value, key];
};
</script>

<template>
  <SectionLayout
    :title="$t('GENERAL_SETTINGS.SIDEBAR_VISIBILITY.TITLE')"
    :description="$t('GENERAL_SETTINGS.SIDEBAR_VISIBILITY.DESCRIPTION')"
    with-border
  >
    <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
      <label
        v-for="option in options"
        :key="option.key"
        class="flex cursor-pointer items-center gap-3 rounded-lg border border-n-weak px-3 py-3 hover:bg-n-alpha-1"
      >
        <Checkbox
          :model-value="isVisible(option.key)"
          @update:model-value="value => setVisibility(option.key, value)"
        />
        <span class="text-sm text-n-slate-12">{{ option.label }}</span>
      </label>
    </div>
  </SectionLayout>
</template>
